<template>
  <v-card elevation="0">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="h1 font-weight-medium">{{ title }}</v-list-item-title>
        <v-list-item-subtitle v-if="subtitle !== undefined">{{ subtitle }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="message !== undefined"><span class="red--text font-weight-bold">{{ message }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="px-0 pt-0 pb-2">
      <v-list dense flat nav class="py-0">
        <v-list-item
          v-for="item in items.filter(x => x.visible)"
          v-bind:key="item.name"
          style="min-height: 32px">
          <v-list-item-icon class="my-1 mr-3">
            <v-tooltip v-if="item.tooltip !== undefined" bottom open-delay="500">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="grey--text">{{ item.icon }}</v-icon>
              </template>
              <span>{{ item.tooltip }}</span>
            </v-tooltip>
            <v-icon v-else v-on="on">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <template
              v-for="(block, index) in item.blocks.filter(x => x.visible === undefined || x.visible)"
              style="min-height: 32px">

              <v-list-item-title v-bind:key="index" v-if="block.slot !== undefined && block.slot !== null">
                <slot :name="block.slot"></slot>
              </v-list-item-title>
              <v-list-item-title v-bind:key="index"
                                 v-else-if="block.subtitle === undefined || block.subtitle === null || !block.subtitle">
                <country-flag v-if="block.flag" :country="block.flag" size="small" />
                <span v-if="block.action !== undefined && block.action !== null" style="cursor: pointer" @click="onAction(block.action)">{{ block.text }}</span>
                <span v-else>{{ block.text }}</span>
              </v-list-item-title>
              <v-list-item-subtitle v-bind:key="index" v-else>
                <country-flag v-if="block.flag" :country="block.flag" size="small" />
                <span v-if="block.action !== undefined && block.action !== null" style="cursor: pointer" @click="onAction(block.action)">{{ block.text }}</span>
                <span v-else>{{ block.text }}</span>
              </v-list-item-subtitle>
            </template>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions v-if="actions.length > 0" class="justify-center">
      <v-tooltip bottom open-delay="500" v-for="action in actions" v-bind:key="action.name">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            rounded
            elevation="0"
            color="primary"
            v-bind="attrs"
            v-on="on"
            class="mx-1"
            @click="onAction(action.action)"
          >
            <v-icon dense>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.text }}</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>

const props = {
  title: {
    type: String,
    default: undefined
  },
  subtitle: {
    type: String,
    custom: true,
    default: undefined
  },
  message: {
    type: String,
    custom: true,
    default: undefined
  },
  items: {
    type: Array,
    default: []
    /*
    [{icon : "mdi-", action: null, tooltip: undefined, blocks: [ {flag: undefined, text: "Pokus", subtitle: false, slot: undefined } ]]
     */
  },
  actions: {
    type: Array,
    default: []
    /*
    [{"text" : "Offline", "action": undefined, "tooltip": undefined} ]
     */
  }
};

export default {
  name: "IconProperties",

  props: props,

  methods: {
    onAction(action) {
      this.$emit("action", action);
    }
  }
};
</script>
